class KenckoVsOthersSection {
  constructor(section) {
    this.section = section;
    this.scrollContainer = section.querySelector('.comparison-table-scroll');
    
    if (this.scrollContainer) {
      this.init();
    }
  }

  init() {
    this.addScrollIndicators();
    this.handleScroll();
  }

  addScrollIndicators() {
    if (window.innerWidth < 768) {
      this.scrollContainer.addEventListener('scroll', () => {
        this.handleScroll();
      });
    }
  }

  handleScroll() {
    const scrollLeft = this.scrollContainer.scrollLeft;
    const scrollWidth = this.scrollContainer.scrollWidth;
    const clientWidth = this.scrollContainer.clientWidth;
    
    if (scrollLeft > 0) {
      this.section.classList.add('is-scrolled');
    } else {
      this.section.classList.remove('is-scrolled');
    }
    
    if (scrollLeft + clientWidth >= scrollWidth - 1) {
      this.section.classList.add('is-at-end');
    } else {
      this.section.classList.remove('is-at-end');
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.section-kencko-vs-others');
  sections.forEach(section => {
    new KenckoVsOthersSection(section);
  });
});
